module.exports = __webpack_public_path__ + "48b1354b02312e14e91d775916287c48.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/drums/9_G#2.mp3
// module id = 66
// module chunks = 0